import * as React from "react";
import Lottie from "react-lottie";
import * as animationData from "@assets/animations/maintenance.json";
import { useSelector } from "react-redux";
import { RootState } from "@services/Redux";

const MaintenancePage: React.FC = () => {
  const companyData = useSelector((state: RootState) => state.company.data);

  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        maxHeight: "100vh",
        minWidth: "100vw",
        maxWidth: "100vw",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        top: 0,
        left: 0,
        flexDirection: "column",
      }}
    >
      {companyData.logo_image ? (
        <img src={`${companyData.logo_image.base_url}/companies/${companyData.id}/media/thumb_3/${companyData.logo_image.key}`} width={250} />
      ) : (
        <Lottie options={{ loop: false, autoplay: true, animationData }} height={250} width={250} />
      )}
      <div style={{ maxWidth: 300, marginTop: 40, textAlign: "center" }}>
        <h5>{companyData.maintenance_mode_message ?? "Olá, para melhorar sua experiência, nosso catálogo virtual está indisponível no momento. Voltamos em breve!"}</h5>
      </div>
    </div>
  );
};

export default MaintenancePage;
